import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
}
export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  className = '',
  icon,
  fullWidth = false,
  href,
  type = 'button'
}) => {
  const baseStyles = 'font-bold rounded-xl transition-all duration-300 flex items-center justify-center gap-3 shadow-lg';
  const variantStyles = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline: 'btn-outline'
  };
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  const buttonClasses = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${className}`;
  const handleClick = (e: React.MouseEvent) => {
    if (href && onClick) {
      e.preventDefault();
      onClick();
    } else if (onClick) {
      onClick();
    }
  };
  if (href) {
    return <a href={href} className={buttonClasses} onClick={handleClick} data-id="element-71">
        {icon && <span className="mr-3" data-id="element-72">{icon}</span>}
        {children}
      </a>;
  }
  return <button type={type} className={buttonClasses} onClick={onClick} data-id="element-73">
      {icon && <span data-id="element-74">{icon}</span>}
      <span className="relative z-10" data-id="element-75">{children}</span>
    </button>;
};